module.exports = __webpack_public_path__ + "static/media/CROWN-PE-4500.608e80ea.jpg";